import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

function Layout() {
    return (
        <div>
            <Navbar />
            <Outlet />  {/* Este componente renderizará la vista correspondiente según la ruta */}
            <Footer />
        </div>
    );
}

export default Layout;
